import SafeImage from '@ui/SafeImage';
import saleBanner from '@features/homepage/assets/images/web_LLsale_banner.webp';
import React from 'react';
import Link from 'next/link';
import { useAuth } from 'context/AuthContext';

const SaleBanner = () => {
  const { userDoc } = useAuth();
  return (
    // 4096 × 1879
    <Link
      href={userDoc ? '/create-listing' : '/signup?redirect=/create-listing'}
    >
      <SafeImage
        src={saleBanner}
        key="sale-banner"
        height={1879}
        width={4096}
        alt="Loretta Lynn's Sale Banner "
      />
    </Link>
  );
};

export default SaleBanner;
